import { IconPropsType } from '..';

export const HeartIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="general=default, betting=default, statuses=default, arrows=default, toggleables=heart-off, signs=default, menus=default, casino=default, currency=default">
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0017 17L16.5618 10.8296L16.5848 10.8081L16.8848 10.5227L16.8733 10.512C18.4715 8.70825 18.3676 6.03227 16.5733 4.34162C14.7847 2.66173 11.9155 4.02471 10 5.5C8.09027 3.99779 5.21876 2.65096 3.42442 4.34162C1.63009 6.03227 1.532 8.71363 3.12441 10.512L3.11287 10.5227L3.41289 10.8081L3.42442 10.8189L10.0017 17ZM10.0017 14.5L14.4827 10.4597L14.5 10.4439L14.725 10.2339L14.7164 10.226C15.915 8.89874 16.8458 7.24402 15.5 6C14.1586 4.7639 11.4366 6.91445 10 8C8.5677 6.89464 5.84575 4.75598 4.5 6C3.15425 7.24402 4.08068 8.89478 5.27499 10.218L5.26633 10.226L5.49135 10.4359L5.5 10.4439L10.0017 14.5Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
